import { render } from "./link.vue?vue&type=template&id=fbb47038"
import script from "./link.vue?vue&type=script&lang=js"
export * from "./link.vue?vue&type=script&lang=js"

import exportComponent from "/home/soller/sync/Work/Enkiro/casdoor-rust-example/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__